<template>
  <div class="mypage">
    <InformationComponent class="mb-3"/>
    <AnnounceComponent class="mb-3"/>
    <ToDoApplicationComponent class="mb-3"/>
    <div class="d-flex flex-wrap">
      <div class="w-25 mb-3">
        <router-link
          :to="{name: 'Students'}"
          class="common__dashboard_link"
        >
          StudentList
        </router-link>
      </div>
      <div class="w-25 mb-3">
        <router-link
          :to="{name: 'SendMailToStudents'}"
          class="common__dashboard_link"
        >
          StudentSendMail
        </router-link>
      </div>
      <div class="w-25 mb-3">
        <router-link
          :to="{
            name: 'ClockIns',
            params: {
              date: today.format('YYYYMMDD'),
            },
          }"
          class="common__dashboard_link"
        >
          Clock-in
        </router-link>
      </div>
    </div>
    <div class="d-flex flex-wrap">
      <div class="w-25 mb-3">
        <a
          class="common__dashboard_link"
          href="https://led.w-as.jp/guide.html"
          rel="noreferrer"
          target="_blank"
        >
          <img src="@/assets/CourseGuide.png">
        </a>
      </div>
      <div class="w-25 mb-3">
        <a
          class="common__dashboard_link"
          href="https://led.w-as.jp/data/te/2021-te-lesson-calender.pdf"
          rel="noreferrer"
          target="_blank"
        >
          <img src="@/assets/AnnualSchedule.png">
        </a>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import Vue from 'vue'
import moment, { Moment } from 'moment'
import ToDoApplicationComponent from '@/components/parts/mypage/ToDoApplicationComponent.vue'
import InformationComponent from '@/components/parts/mypage/InformationComponent.vue'
import AnnounceComponent from '@/components/parts/mypage/AnnounceComponent.vue'

export default Vue.extend({
  components: {
    InformationComponent,
    ToDoApplicationComponent,
    AnnounceComponent,
  },

  computed: {
    today: (): Moment => moment(),
  },
})
</script>
